"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestEmailCheckInvitesPublic = exports.requestEmailCheckPublicTS = void 0;
const fetch_1 = __importDefault(require("../util/fetch"));
const error_1 = __importDefault(require("../util/error"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const error_handler_1 = require("@app/util/error-handler");
const apollo_1 = require("@app/util/apollo");
const emailCheckPublicQuery = (0, graphql_tag_1.default) `query EmailCheckPublicQuery (
  $email: String!
) {
  emailCheckPublic (
    email: $email
  )
}`;
const requestEmailCheckPublicTS = async (val) => {
    const { data, errors } = await (0, apollo_1.query)(emailCheckPublicQuery, {
        variables: {
            email: val.trim(),
        },
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.emailCheckPublic;
};
exports.requestEmailCheckPublicTS = requestEmailCheckPublicTS;
const emailCheckInvitesPublicQuery = (0, graphql_tag_1.default) `query EmailCheckInvitesPublicQuery (
  $email: String!
) {
  inviteCheckPublic (
    email: $email
  )
}`;
const requestEmailCheckInvitesPublic = async (val) => {
    const { data, errors } = await (0, apollo_1.query)(emailCheckInvitesPublicQuery, {
        variables: {
            email: val.trim(),
        },
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.inviteCheckPublic;
};
exports.requestEmailCheckInvitesPublic = requestEmailCheckInvitesPublic;
/**
* @deprecated Use `requestEmailCheckPublicTS` instead
*/
async function requestEmailCheckPublic(variables) {
    const response = await (0, fetch_1.default)({
        variables,
        query: emailCheckPublicQuery,
    });
    if (!response)
        return error_1.default.noResponse();
    // @ts-expect-error
    const { errors, data } = response;
    if (errors) {
        return error_1.default.apiError('email-check-public', errors);
    }
    return data.emailCheckPublic;
}
exports.default = requestEmailCheckPublic;
